import type { ReactNode } from 'react'
import React from 'react'
import { HoverContainer, HoverMenuContainer } from '../hover-menu'
import { HorizontalStack } from '@ztechapps/webui.util'

export type ContainerWithContextMenuProps = {
  children?: ReactNode
  contextMenuContent?: ReactNode
  disabled?: boolean
  as?: any
  className?: string
  style?: React.CSSProperties
}
export const ContainerWithContextMenu = ({
  children,
  contextMenuContent,
  disabled,
  as,
  className,
  style,
}: ContainerWithContextMenuProps) => {
  return (
    <HoverContainer as={as} disabled={disabled} className={className} style={style}>
      <HorizontalStack gap={3} className="align-items-start">
        <div className="" style={{ minWidth: 0 }}>
          {children}
        </div>
        <HoverMenuContainer className="flex-shrink-0 text-nowrap">{contextMenuContent}</HoverMenuContainer>
      </HorizontalStack>
    </HoverContainer>
  )
}
